










import { Vue, Component } from 'vue-property-decorator';
import PublicNavbar from '@/components/public/Navbar.vue';
import PublicBottomFooter from '@/components/public/BottomFooter.vue';
import VueVideoSection from 'vue-video-section';
import 'vue-video-section/dist/vue-video-section.css';

Vue.component('vue-video-section', VueVideoSection);

@Component({
  components: {
    PublicNavbar,
    PublicBottomFooter,
  },
})
export default class PublicRoot extends Vue {}
